export interface Asn {
  id: number;
  nome_asn: string;
  asn: string;
}

export type AsnPayload = Omit<Asn, "id">;

export type AsnFormErrors = Partial<Record<keyof AsnPayload, string>>;

export interface AsnsApiResponse {
  success: boolean;
  data: Asn[];
}

export const ASN_FIELDS: Array<keyof AsnPayload> = ["nome_asn", "asn"];

export const emptyAsn: AsnPayload = {
  nome_asn: "",
  asn: "",
};
